module.exports = __webpack_public_path__ + "static/media/fuco.90ce01c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/team/fuco.jpg
// module id = 168
// module chunks = 0